import {
  GOOGLE_MAP_SET_ADDRESS_VALUE,
  SET_DEALER_ADDRESS_SELECTION_VALIDATION,
  GOOGLE_MAP_SET_MULTIPLE_ADDRESS_VALUE,
  LOAD_LOCATIONS_MODEL,
  LOAD_LOCATIONS_MODEL_PATH,
  GOOGLE_MAP_SET_ADDRESS_LAT_LAN_VALUE,
  TODAY_HOURS_FOR_EACH_DEPARTMENT,
  GOOGLE_MAP_SET_SELECTED_DEALER_ADDRESS_OBJECT,
  SET_BUSINESS_HOURS_DATA,
} from '../StoreConstants/GoogleMapConstants';

export const GoogleMapStore = {
  state: {
    selectedAddress: window.isDealerGroup ? window.fullAddress : '',
    addressSelectionError: false,
    selectedAddressLatLan: {
      latitude: window.latitude,
      longitude: window.longitude,
    },
    selectedMultipleAddress: '',
    loadLocationsModel: false,
    locationModalPath: '',
    todayHours: {},
    selectedDealerAddressObj: null,
    businessHoursData: [],
  },
  mutations: {
    [GOOGLE_MAP_SET_ADDRESS_VALUE](state, payload) {
      state.selectedAddress = payload;
    },
    [SET_DEALER_ADDRESS_SELECTION_VALIDATION](state, payload) {
      state.addressSelectionError = payload;
    },
    [GOOGLE_MAP_SET_ADDRESS_LAT_LAN_VALUE](state, payload) {
      state.selectedAddressLatLan = payload;
    },
    [GOOGLE_MAP_SET_MULTIPLE_ADDRESS_VALUE](state, payload) {
      state.selectedMultipleAddress = payload;
    },
    [LOAD_LOCATIONS_MODEL](state, payload) {
      state.loadLocationsModel = payload;
    },
    [LOAD_LOCATIONS_MODEL_PATH](state, payload) {
      state.locationModalPath = payload;
    },
    [TODAY_HOURS_FOR_EACH_DEPARTMENT](state, payload) {
      state.todayHours = payload;
    },
    [GOOGLE_MAP_SET_SELECTED_DEALER_ADDRESS_OBJECT](state, payload) {
      state.selectedDealerAddressObj = payload;
    },
    [SET_BUSINESS_HOURS_DATA](state, payload) {
      state.businessHoursData = payload;
    },
  },
};
